/**
 * Widget preset registry — all widget definitions live alongside this file.
 *
 * Preset definitions  : *.ts  files in this directory
 * React renderers     : *Widget.tsx files in this directory
 * Node shell/routing  : ../WidgetNode.tsx
 */

export type { WidgetPreset } from "./types";

// ── Collaborative / interactive ─────────────────────────────────────────────
import { MUSIC_PLAYER } from "./music-player";
import { RETRO_BOARD } from "./retro-board";
import { TIMER_DIGITAL } from "./timer-digital";

// ── Decorative ──────────────────────────────────────────────────────────────
import { BIG_BRAIN } from "./big-brain";
import { CAUTION_ZONE } from "./caution-zone";
import { DRAFT_STAMP } from "./draft-stamp";
import { EARTH_MOON } from "./earth-moon-orbit";
import { HOT_TAKE } from "./hot-take";
import { LIGHT_BULB } from "./lightbulb";
import { NEON_SIGN } from "./neon-sign";
import { PLOT_TWIST } from "./plot-twist";
import { QUICK_WIN } from "./quick-win";
import { SHIP_IT } from "./ship-it";
import { SPEECH_BUBBLE } from "./speech-bubble";

import type { WidgetPreset } from "./types";

export const WIDGET_PRESETS: WidgetPreset[] = [
  TIMER_DIGITAL,
  MUSIC_PLAYER,
  RETRO_BOARD,
  DRAFT_STAMP,
  BIG_BRAIN,
  LIGHT_BULB,
  SHIP_IT,
  // Everything else
  HOT_TAKE,
  CAUTION_ZONE,
  QUICK_WIN,
  SPEECH_BUBBLE,
  PLOT_TWIST,
  NEON_SIGN,
  EARTH_MOON,
];

/**
 * Lookup map for all widget presets.
 * Used by WidgetNode action handlers to find rebuildHtml for a given presetId.
 */
export const WIDGET_ALL_PRESET_MAP = new Map<string, WidgetPreset>(
  WIDGET_PRESETS.map((p) => [p.id, p]),
);
